import React from 'react';
import { Row, Col, Card, Typography, Space } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined, DollarCircleOutlined, PieChartOutlined, BarChartOutlined } from '@ant-design/icons';
import { IncomeExpenseAreaChart, ProfitPieChart, InvoiceColumnChart } from './DashboardChart';

const { Title, Text } = Typography;

const DashboardAnalytics = ({ income = 0, expenses = 0, profit = 0, recentInvoices = [], recentExpenses = [] }) => {
  // Demo chart data (replace with real aggregation if available)
  const areaData = [
    { month: 'Jan', value: income * 0.7, type: 'Income' },
    { month: 'Feb', value: income * 0.8, type: 'Income' },
    { month: 'Mar', value: income, type: 'Income' },
    { month: 'Jan', value: expenses * 0.6, type: 'Expenses' },
    { month: 'Feb', value: expenses * 0.9, type: 'Expenses' },
    { month: 'Mar', value: expenses, type: 'Expenses' },
  ];
  const pieData = [
    { type: 'Profit', value: profit > 0 ? profit : 0 },
    { type: 'Expenses', value: expenses },
  ];
  const invoiceStatus = [
    { status: 'Paid', count: recentInvoices.filter(i => i.paid === 'Y').length },
    { status: 'Not Paid', count: recentInvoices.filter(i => i.paid !== 'Y').length },
  ];

  return (
    <div>
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8}>
          <Card bordered={false} style={{ background: '#f6ffed', boxShadow: '0 2px 8px #52c41a22' }}>
            <Space>
              <DollarCircleOutlined style={{ color: '#52c41a', fontSize: 32 }} />
              <div>
                <Text strong>Total Income</Text>
                <Title level={3} style={{ margin: 0, color: '#389e0d' }}>${income.toFixed(2)}</Title>
              </div>
            </Space>
          </Card>
        </Col>
        <Col span={8}>
          <Card bordered={false} style={{ background: '#fff7e6', boxShadow: '0 2px 8px #faad1422' }}>
            <Space>
              <ArrowDownOutlined style={{ color: '#faad14', fontSize: 32 }} />
              <div>
                <Text strong>Total Expenses</Text>
                <Title level={3} style={{ margin: 0, color: '#d48806' }}>${expenses.toFixed(2)}</Title>
              </div>
            </Space>
          </Card>
        </Col>
        <Col span={8}>
          <Card bordered={false} style={{ background: '#e6f7ff', boxShadow: '0 2px 8px #1890ff22' }}>
            <Space>
              <ArrowUpOutlined style={{ color: '#1890ff', fontSize: 32 }} />
              <div>
                <Text strong>Net Profit</Text>
                <Title level={3} style={{ margin: 0, color: '#096dd9' }}>${profit.toFixed(2)}</Title>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}><IncomeExpenseAreaChart data={areaData} /></Col>
        {/*<Col span={6}><ProfitPieChart data={pieData} /></Col>*/}
        <Col span={6}><InvoiceColumnChart data={invoiceStatus} /></Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 24 }}>
        <Col span={12}>
          <Card title={<span><BarChartOutlined /> Recent Invoices</span>} bordered={false}>
            {recentInvoices.length === 0 ? 'No data' : (
              <ul style={{ paddingLeft: 16 }}>{recentInvoices.map(inv => (
                <li key={inv.id}>
                  <b>{inv.dated}</b> — <span style={{ color: '#52c41a' }}>${inv.grandTotal || inv.total || inv.amount}</span> — <span style={{ color: inv.paid === 'Y' ? '#389e0d' : '#faad14' }}>{inv.paid === 'Y' ? 'Paid' : 'Not Paid'}</span>
                </li>
              ))}</ul>
            )}
          </Card>
        </Col>
        <Col span={12}>
          <Card title={<span><PieChartOutlined /> Recent Expenses</span>} bordered={false}>
            {recentExpenses.length === 0 ? 'No data' : (
              <ul style={{ paddingLeft: 16 }}>{recentExpenses.map(exp => (
                <li key={exp.id}>
                  <b>{exp.createdDate}</b> — <span style={{ color: '#faad14' }}>${exp.claimedAmount}</span> — <span style={{ color: exp.paid === 'Y' ? '#389e0d' : '#faad14' }}>{exp.paid === 'Y' ? 'Paid' : 'Not Paid'}</span>
                </li>
              ))}</ul>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardAnalytics;
